{
  document.addEventListener("DOMContentLoaded", (event) => {
  // // First initialize the thumbs slider
  // var galleryThumbs = new Swiper(".thumb-slider", {
  //   slidesPerView: 4,
  //   spaceBetween: 15,
  //   freeMode: true,
  //   watchSlidesVisibility: true,
  //   watchSlidesProgress: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     200: {
  //       slidesPerView: 4,
  //     },
  //     600: {
  //       slidesPerView: 4,
  //     },
  //   },
  // });

  // // Then initialize the main slider with the thumbs reference
  // new Swiper(".gallery-slider", {
  //   slidesPerView: 1,
  //   thumbs: {
  //     swiper: galleryThumbs,
  //   },
  //   breakpoints: {
  //     200: {
  //       slidesPerView: 1,
  //     },
  //     600: {
  //       effect: "fade",
  //       slidesPerView: 1,
  //     },
  //   },
  // });

  const scrollButtons = document.querySelectorAll(".scroll-btn-new");

  scrollButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = button.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offset = 50;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});


///
function initProductGallery() {
  const productSection = document.querySelector(".--main-product-section");
  if (!productSection || typeof Swiper === "undefined") return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.initGallery(productSection);
    });
  });
}

if (document.readyState === "complete") {
  initProductGallery();
} else {
  window.addEventListener("DOMContentLoaded", initProductGallery, { once: true });
}

// Ios Fallback
window.addEventListener("pageshow", () => {
  const productSection = document.querySelector(".--main-product-section");
  if (!productSection) return;

  requestAnimationFrame(() => {
    productSection.querySelector(".thumb-slider")?.swiper?.update();
    productSection.querySelector(".gallery-slider")?.swiper?.update();
  });
});
///

const accordionWrappers = document.querySelectorAll(".accordion__wrapper-ab");
accordionWrappers.forEach((wrapper, index) => {
  const title = wrapper.querySelector(".accr__title");
  const content = wrapper.querySelector(".accr__content");

  if (index === 0) {
    wrapper.classList.add("accordion-open");
    // content.style.maxHeight = content.scrollHeight + "px";
  } else {
    wrapper.classList.add("accordion-closed");
  }

  title.addEventListener("click", () => {
    const isOpen = wrapper.classList.contains("accordion-open");

    accordionWrappers.forEach((otherWrapper) => {
      if (otherWrapper !== wrapper) {
        otherWrapper.classList.remove("accordion-open");
        otherWrapper.classList.add("accordion-closed");
        // otherWrapper.querySelector(".accr__content").style.maxHeight = "0";
      }
    });

    if (isOpen) {
      wrapper.classList.remove("accordion-open");
      wrapper.classList.add("accordion-closed");
      // content.style.maxHeight = "0";
    } else {
      wrapper.classList.remove("accordion-closed");
      wrapper.classList.add("accordion-open");
      // content.style.maxHeight = content.scrollHeight + "px";
      // content.style.maxHeight ="max-content";
    }
  });
});


/////////
  // Add to cart Functionality
 //<a data-id="{{ product.selected_or_first_available_variant.id }}" onclick="window.onClickAtc(event,this);">

  window.onClickAtc = async function (e,button) {
  e.preventDefault();
  

  const originalText = button.textContent.trim();
  button.textContent = 'Adding...';


  let productInfo = button.closest('.product-info');
  let selectedVariant = productInfo.querySelector('.--single-variant.--active-variant');


    if (!selectedVariant) {
    console.error('No active variant found');
    return;
  }

  let id = Number(selectedVariant.dataset.id.trim());

  
  const formData = {
   'items': [{
    'id': id,
    'quantity': 1
   }]
  };

  
  try {
   const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
   });
  
   if (response.ok) {
    // button.textContent = 'Added!';
    button.textContent = originalText;
    window.location.href = '/cart';
   } else {
    button.textContent = originalText;
    console.error('Error add to cart');
   }
  } catch (error) {
    button.textContent = originalText;
   console.error('Network error:', error);
  }
 }
//////////



// Variant Management

window.variantClick = function (e, button) {
  e.preventDefault();

  if (button.classList.contains("--active-variant")) return;

  const variantId = button.dataset.id.trim();
  const section = button.closest(".--main-product-section");

  if (!section) return;


    // Switch variant button
    section.querySelectorAll(".--single-variant").forEach((variant) => {
      variant.classList.remove("--active-variant");
    });

    button.classList.add("--active-variant");


    // Switch matching description
    section.querySelectorAll(".--single-variant-description").forEach((description) => {
        const isActive = description.dataset.id.trim() === variantId;
        description.classList.toggle("--active", isActive);
    });

    // Switch What's in the Box 
    section.querySelectorAll(".accordion__wrapper-ab.--whats-in-the-box").forEach((item) => {
        const isActive = item.dataset.id.trim() === variantId;
        item.classList.toggle("--active-variant", isActive);
    });

    // Switch Technical Specifications
    section.querySelectorAll(".accordion__wrapper-ab.--technical-specifications").forEach((item) => {
        const isActive = item.dataset.id.trim() === variantId;
        item.classList.toggle("--active-variant", isActive);
    });

  



    // console.log(`Selected variant: ${variantId}`);
    // Update price
    window.variantPrice();
    // Update price
    window.updateMedia(button);
};



///



window.variantPrice = function (button = null) { 
  const activeVariant = button || document.querySelector('.--single-variant.--active-variant'); 
  if (!activeVariant) return; 

  const section = activeVariant.closest('.--main-product-section'); 
  if (!section) return; 

  const priceWrapper = section.querySelector('.--price-wrapper'); 
  const pricePerDay = section.querySelector('.--price-per-day'); 
  if (!priceWrapper) return; 

  const currencySymbol = activeVariant.dataset.currencySymbol || ''; 
  const regularPrice = Number(activeVariant.dataset.regularPrice || 0); 
  const comparePrice = Number(activeVariant.dataset.comparePrice || 0); 
  const pricePerDayValue = activeVariant.dataset.pricePerDay || ''; 

  if (comparePrice > regularPrice) {
    priceWrapper.innerHTML = `
      <div class="--price-regular">${currencySymbol}${regularPrice.toFixed(2)}</div>
      <div class="--price-compare">${currencySymbol}${comparePrice.toFixed(2)}</div>
    `; 
  } else {
    priceWrapper.innerHTML = `
      <div class="--price-regular">${currencySymbol}${regularPrice.toFixed(2)}</div>
    `; 
  }

  if (pricePerDay) {
    pricePerDay.textContent = pricePerDayValue;
  }
};




window.updateMedia = function (activeVariant) {
  if (!activeVariant) return;

  const section = activeVariant.closest(".--main-product-section");
  if (!section) return;

  const raw = activeVariant.dataset.media;
  if (!raw) return;

  const mainEl   = section.querySelector(".gallery-slider");
  const thumbsEl = section.querySelector(".thumb-slider");
  if (!mainEl || !thumbsEl) return;

  const mainWrap  = mainEl.querySelector(".swiper-wrapper");
  const thumbWrap = thumbsEl.querySelector(".swiper-wrapper");
  if (!mainWrap || !thumbWrap) return;

  let media;
  try {
   
    media = JSON.parse(raw.trim().replace(/^`|`$/g, ""));
  } catch (err) {
    console.error("updateMedia: bad data-media JSON", err);
    return;
  }
  if (!Array.isArray(media) || !media.length) return;

  const sorted = media
    .slice()
    .sort((a, b) => (a.position || 0) - (b.position || 0));

  
  const MP4 = /^video\/mp4$/i;

  const sized = (src, w) => {
    try {
      const u = new URL(src, window.location.href);
      u.searchParams.set("width", w);
      return u.href;
    } catch (e) {
      return src;
    }
  };

  const buildVideo = (item, poster) => {
    
    const source = (item.sources || []).find((s) => MP4.test(s.mime_type || ""));
    if (!source) return null;

    return (
      "<video autoplay loop muted playsinline " +
      `poster="${poster}" preload="metadata">` +
        `<source src="${source.url}" type="${source.mime_type}">` +
      "</video>"
    );
  };

  const buildSlide = (item, index, width, allowVideo) => {
    const src = item.preview_image?.src || item.src;
    if (!src) return "";

    const poster = sized(src, width);
    const alt    = String(item.alt || "").replace(/"/g, "&quot;");
    const ratio  = item.aspect_ratio || item.preview_image?.aspect_ratio || 1;
    const height = Math.round(width / ratio);

    let inner = null;
    if (allowVideo && item.media_type === "video") {
      inner = buildVideo(item, poster);
    }

    if (!inner) {
      const load =
        index === 0
          ? 'loading="eager" fetchpriority="high" decoding="sync"'
          : 'loading="lazy" decoding="async"';
      inner =
        `<img src="${poster}" alt="${alt}" ` +
        `width="${width}" height="${height}" ${load}>`;
    }

    return `<div class="swiper-slide">${inner}</div>`;
  };

  const mainHTML  = sorted.map((m, i) => buildSlide(m, i, 700, true)).join("");
  const thumbHTML = sorted.map((m, i) => buildSlide(m, i, 250, false)).join("");
  if (!mainHTML) return;

 
  mainEl.swiper?.destroy(true, true);
  thumbsEl.swiper?.destroy(true, true);

  mainWrap.innerHTML  = mainHTML;
  thumbWrap.innerHTML = thumbHTML;

 

  window.initGallery(section);
};
window.initGallery = function (section) {
  if (!section) return;

  const mainEl   = section.querySelector(".gallery-slider");
  const thumbsEl = section.querySelector(".thumb-slider");
  if (!mainEl || !thumbsEl) return;

  if (mainEl.swiper || thumbsEl.swiper) return;

  const thumbs = new Swiper(thumbsEl, {
    slidesPerView: 4,
    spaceBetween: 15,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: thumbsEl.querySelector(".swiper-button-next"),
      prevEl: thumbsEl.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      200: { slidesPerView: 4 },
      600: { slidesPerView: 4 },
    },
  });


  

  new Swiper(mainEl, {
    slidesPerView: 1,
    thumbs: { swiper: thumbs },
    breakpoints: {
      200: { slidesPerView: 1 },
      600: { effect: "fade", slidesPerView: 1 },
    },
  });


};
}